<div class="fullheight" [hidden]="!ViewReady">
    <div fxLayout="column" fxLayoutAlign="start stretch">
        <button
            type="button"
            *ngIf="ParamsPreviousPage === 'search' && LastSearchResults != null && LastSearchOptions != null"
            mat-raised-button
            color="accent"
            (click)="HandleSearchReturn()"
        >
            Back to Search Results
        </button>
        <div *ngIf="UnableToView">
            The IRIS request that you have requested to view is currently unavailable. We apologize for the inconvenience.
        </div>
        <h2 [hidden]="UnableToView" class="mat-headline">
            Request #{{ LoadedRequest?.RequestIssueNumber | requestIssue: LoadedRequest?.FiscalYear }}
        </h2>
        <form [hidden]="UnableToView" [formGroup]="RequestForm" novalidate #requestfrm="ngForm">
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap.gt-sm="30px"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="start stretch"
            >
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Subject:</app-form-label>
                    <div>{{ LoadedRequest?.Subject }}</div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Category:</app-form-label>
                    <div *ngIf="LoadedRequest?.CategoryID != null">
                        <span>{{ LoadedRequest?.CategoryID | category: AllCategories }}</span>
                        <span
                            *ngIf="['Facilitator', 'Developer', 'Superintendent', 'DeputySuperintendent'].includes(User.CurrentRole)"
                        >
                            <strong> ({{ LoadedRequest?.CategoryID | categoryCabinet: AllCategories }})</strong></span
                        >
                    </div>
                    <div *ngIf="LoadedRequest?.CategoryID == null">N/A</div>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap.gt-sm="30px"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="start stretch"
            >
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Opened:</app-form-label>
                    <div>{{ LoadedRequest?.DateCreated | date: 'M/d/yyyy h:mm a' }}</div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Current Referral Bearer:</app-form-label>
                    <div *ngIf="LoadedRequest?.Status !== 'FOLLOWUP'; else followup">
                        {{ LoadedRequest?.ResponderInfo?.FirstName | titleCase }}
                        {{ LoadedRequest?.ResponderInfo?.LastName | titleCase }}
                    </div>
                    <ng-template #followup
                        ><div>Follow-Up Pending ({{ LoadedRequest?.CategoryID | categoryCabinet: AllCategories }})</div></ng-template
                    >
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap.gt-sm="30px"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="start stretch"
            >
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Closed:</app-form-label>
                    <div *ngIf="LoadedRequest?.RequestIsClosed">
                        <span>{{ LoadedRequest?.DateClosed | date: 'M/d/yyyy h:mm a' }}</span>
                        <span *ngIf="LoadedRequest?.ActualJobTime != null">
                            ({{ LoadedRequest?.ActualJobTime | number: '1.1-1' }} hrs worked)</span
                        >
                    </div>
                    <div *ngIf="LoadedRequest?.RequestIsClosed !== true">
                        <span *ngIf="LoadedRequest?.Status !== 'FOLLOWUP'">N/A</span>
                        <span *ngIf="LoadedRequest?.Status === 'FOLLOWUP'">Follow-Up Pending</span>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Priority:</app-form-label>
                    <div>
                        <span>{{ LoadedRequest?.Priority | priority }}</span>
                        <span
                            *ngIf="['Facilitator', 'Developer', 'Superintendent', 'DeputySuperintendent'].includes(User.CurrentRole)"
                        >
                            (Original: {{ LoadedRequest?.OriginalPriority | priority }})</span
                        >
                    </div>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap.gt-sm="30px"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="start stretch"
            >
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>School:</app-form-label>
                    <div>{{ LoadedRequest?.SchoolNumber | schoolName }}</div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Due:</app-form-label>
                    <div *ngIf="LoadedRequest?.DueDate != null">{{ LoadedRequest?.DueDate | date: 'M/d/yyyy' }}</div>
                    <div *ngIf="LoadedRequest?.DueDate == null">Not Assigned</div>
                </div>
            </div>
            <div
                *ngIf="
                    User.CurrentRole === 'Cabinet' ||
                    User.CurrentRole === 'Responder' ||
                    User.CurrentRole === 'Facilitator' ||
                    User.CurrentRole === 'Developer' ||
                    User.CurrentRole === 'Superintendent' ||
                    User.CurrentRole === 'DeputySuperintendent'
                "
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap.gt-sm="30px"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="start stretch"
            >
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>Board Member:</app-form-label>
                    <div>
                        {{ LoadedRequest?.RequestorInfo?.FirstName | titleCase }}
                        {{ LoadedRequest?.RequestorInfo?.LastName | titleCase }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                    <app-form-label>District:</app-form-label>
                    <div *ngIf="LoadedRequest?.BoardDistrict">District {{ LoadedRequest?.BoardDistrict }}</div>
                    <div *ngIf="!LoadedRequest?.BoardDistrict">All / District-Wide</div>
                </div>
            </div>
            <div
                *ngIf="
                    (User.CurrentRole === 'Cabinet' || User.CurrentRole === 'Responder') &&
                    ['REFERRED', 'REFTIMEAPP'].includes(LoadedRequest?.Status)
                "
                class="margin-top margin-bottom"
            >
                <em
                    >Reminder: Requests which are anticipated to take two (2) or more hours to complete should first seek school board
                    approval for the estimated job hours before proceeding. Please use the "Request Time Approval" button to make this
                    request.</em
                >
            </div>
            <section [hidden]="SmallSize" class="mat-elevation-z5">
                <mat-tab-group [(selectedIndex)]="SelectedTabIndex" [dynamicHeight]="true">
                    <mat-tab>
                        <ng-template mat-tab-label>Request / Concern</ng-template>
                        <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                            <div>This is the request / concern entered by the original creator of the request:</div>
                            <div class="usertext">{{ LoadedRequest?.RequestText }}</div>
                            <div *ngIf="LoadedRequest?.Confidential">
                                <strong
                                    >Note: This request has been marked as containing confidential student and/or parent
                                    information.</strong
                                >
                            </div>
                            <div *ngIf="IsiPad && LoadedRequest && !!LoadedRequest?.RequestAttachments.length" class="padding-top">
                                <em
                                    >File attachment downloads may not be possible from an Apple iPhone or iPad device. To reliably
                                    download files, please log in to the IRIS system using a desktop device to retrieve file
                                    attachments.</em
                                >
                            </div>
                            <div class="padding-top">
                                <div *ngIf="!LoadedRequest || !LoadedRequest?.RequestAttachments.length">
                                    There are no files attached to this request.
                                </div>
                                <div *ngIf="LoadedRequest && !!LoadedRequest?.RequestAttachments.length">
                                    <em>The following file attachments were attached to this request when it was created:</em>
                                </div>
                                <table
                                    class="mat-table fullwidth margin-top row-margin"
                                    *ngIf="LoadedRequest && !!LoadedRequest?.RequestAttachments.length"
                                >
                                    <thead>
                                        <tr class="mat-header-row">
                                            <th class="mat-header-cell">File Name</th>
                                            <th class="mat-header-cell centered">File Size</th>
                                            <th class="mat-header-cell centered">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="mat-row" *ngFor="let item of LoadedRequest?.RequestAttachments; index as $index">
                                            <td class="mat-cell">
                                                <div>{{ item.FileName }}</div>
                                            </td>
                                            <td class="mat-cell centered">
                                                <div>{{ item.FileSize | fileSize }}</div>
                                            </td>
                                            <td class="mat-cell">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button
                                                        type="button"
                                                        mat-raised-button
                                                        color="primary"
                                                        (click)="HandleFileAttachment(item)"
                                                    >
                                                        Download
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab
                        *ngIf="
                            (LoadedRequest?.Comments && !!LoadedRequest?.Comments.length) ||
                            ['Developer', 'Facilitator'].includes(User.CurrentRole)
                        "
                    >
                        <ng-template mat-tab-label> <span>Internal Request Notes</span> </ng-template>
                        <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                            <div>
                                The following internal notes have been attached to this referral by previous handlers of the request:
                            </div>
                            <table
                                mat-table
                                [dataSource]="CommentsData"
                                matSort
                                matSortActive="DateCommentAdded"
                                matSortDirection="desc"
                            >
                                <ng-container matColumnDef="DateCommentAdded">
                                    <th mat-header-cell *matHeaderCellDef>Comment Date</th>
                                    <td mat-cell *matCellDef="let com">
                                        <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Comment">
                                    <th mat-header-cell *matHeaderCellDef>Comment</th>
                                    <td mat-cell *matCellDef="let com">
                                        <div [innerHTML]="com.Comment"></div>
                                        <button
                                            type="button"
                                            *ngIf="
                                                com.HasRelatedLink &&
                                                (['Developer', 'Facilitator'].includes(User.CurrentRole) ||
                                                    User.SAPID === LoadedRequest?.RequestorInfo?.SAPID)
                                            "
                                            mat-raised-button
                                            color="accent"
                                            (click)="GoToRelated(com)"
                                        >
                                            Go To...
                                        </button>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="CommentCreatorFullName">
                                    <th mat-header-cell *matHeaderCellDef>Comment Source</th>
                                    <td mat-cell *matCellDef="let com">
                                        <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                        <div>{{ com.CommentCreatorLocalJobTitle }}</div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="CommentRecipientFullName">
                                    <th mat-header-cell *matHeaderCellDef>Comment Recipient</th>
                                    <td mat-cell *matCellDef="let com">
                                        <div>{{ com.CommentRecipientFullName | titleCase }}</div>
                                        <div>{{ com.CommentRecipientLocalJobTitle }}</div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="NoData">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let com" [attr.colspan]="CommentsVisibleColumns?.length">
                                        <em>No internal notes have been attached to this referral at this time.</em>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="SmallSize">
                                    <th mat-header-cell *matHeaderCellDef>Comments</th>
                                    <td mat-cell *matCellDef="let com">
                                        <div fxLayout="column" fxLayoutAlign="start stretch">
                                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                                <div>Comment Date:</div>
                                                <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                                <div>Commenter:</div>
                                                <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                            </div>
                                            <div fxLayout="column" fxLayoutAlign="start stretch">
                                                <div>Comment:</div>
                                                <div [innerHTML]="com.Comment"></div>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="CommentsVisibleHeaders"></tr>
                                <tr
                                    mat-row
                                    *matRowDef="let com; columns: CommentsVisibleColumns; let $even = even"
                                    [class.primarybackground50]="$even"
                                ></tr>
                            </table>

                            <div fxLayout="row" fxLayoutAlign="center center" class="margin-top">
                                <button
                                    type="button"
                                    *ngIf="['Developer', 'Facilitator'].includes(User.CurrentRole)"
                                    mat-raised-button
                                    color="primary"
                                    (click)="AddBoardNote()"
                                >
                                    Add Note To Board Member
                                </button>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="ResponseMode != null">
                        <ng-template mat-tab-label>Resolution / Response</ng-template>
                        <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                            <div *ngIf="LoadedRequest?.Status === 'DENIED'">
                                There was no response provided to this request. The request was closed because the amount of time
                                required to complete the request was not approved.
                            </div>
                            <div *ngIf="LoadedRequest?.Status === 'CLOSEDNONINFO'">
                                There was no response provided to this request. The request was closed because the request was not a
                                request for information.
                            </div>
                            <div *ngIf="LoadedRequest?.Status !== 'DENIED' && LoadedRequest?.Status !== 'CLOSEDNONINFO'">
                                <div *ngIf="LoadedRequest?.Responses && !!LoadedRequest?.Responses.length">
                                    <em>
                                        <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length > 1"
                                            >The following responses were provided by individuals responding to this request:</span
                                        >
                                        <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length === 1"
                                            >The following response was provided by the individual responding to this request:</span
                                        >
                                    </em>
                                </div>
                                <table
                                    class="mat-table fullwidth margin-top row-margin"
                                    *ngIf="!SmallSize && LoadedRequest?.Responses && !!LoadedRequest?.Responses.length"
                                >
                                    <thead>
                                        <tr class="mat-header-row">
                                            <th class="mat-header-cell">Response</th>
                                            <th class="mat-header-cell centered">Date Added</th>
                                            <th
                                                class="mat-header-cell centered"
                                                *ngIf="User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant'"
                                            >
                                                Responder
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="mat-row" *ngFor="let item of LoadedRequest?.Responses; index as $index">
                                            <td class="mat-cell">
                                                <div>{{ item.Response }}</div>
                                                <div *ngIf="item.Confidential">
                                                    <strong
                                                        >Note: The creator of this response has marked this response as containing
                                                        confidential student and/or parent information.</strong
                                                    >
                                                </div>
                                            </td>
                                            <td class="mat-cell centered">
                                                <div class="wide-margin-left wide-margin-right">
                                                    {{ item.DateAdded | date: 'M/d/yyyy' }}
                                                </div>
                                            </td>
                                            <td
                                                class="mat-cell centered"
                                                *ngIf="User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant'"
                                            >
                                                <div *ngIf="item.ResponderDesigneeSAPID">
                                                    {{ item.ResponderDesigneeFirstName | titleCase }}
                                                    {{ item.ResponderDesigneeLastName | titleCase }} ({{
                                                        item.ResponderDesigneeLocalJobTitle
                                                    }})
                                                </div>
                                                <div *ngIf="item.ResponderDesigneeSAPID">
                                                    <em><strong>providing response on behalf of</strong></em>
                                                </div>
                                                <div>
                                                    {{ item.ResponderFirstName | titleCase }}
                                                    {{ item.ResponderLastName | titleCase }} ({{ item.ResponderLocalJobTitle }})
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <ng-container *ngIf="SmallSize && LoadedRequest?.Responses && !!LoadedRequest?.Responses.length">
                                    <div
                                        *ngFor="let item of LoadedRequest?.Responses; index as $index"
                                        fxLayout="column"
                                        fxLayoutAlign="start stretch"
                                        fxLayoutGap="5px"
                                    >
                                        <div><strong>Response:</strong></div>
                                        <em>{{ item.Response }}</em>
                                        <div *ngIf="item.ResponseConfidential">
                                            <strong
                                                >Note: The creator of this response has marked this response as containing confidential
                                                student and/or parent information.</strong
                                            >
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between start">
                                            <span><strong>Date Added</strong></span>
                                            <div>{{ item.DateAdded | date: 'M/d/yyyy' }}</div>
                                        </div>
                                        <div
                                            *ngIf="User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant'"
                                            fxLayout="column"
                                            fxLayoutAlign="start stretch"
                                        >
                                            <span><strong>Responder:</strong></span>
                                            <div fxLayout="row" fxLayoutAlign="end start">
                                                <div *ngIf="item.ResponderDesigneeSAPID">
                                                    {{ item.ResponderDesigneeFirstName | titleCase }}
                                                    {{ item.ResponderDesigneeLastName | titleCase }}
                                                </div>
                                            </div>
                                            <div *ngIf="item.ResponderDesigneeLocalJobTitle" fxLayout="row" fxLayoutAlign="end start">
                                                <span>({{ item.ResponderDesigneeLocalJobTitle }})</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="end start">
                                                <div *ngIf="item.ResponderDesigneeSAPID">
                                                    <em><strong>providing response on behalf of</strong></em>
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="end start">
                                                <div>
                                                    {{ item.ResponderFirstName | titleCase }} {{ item.ResponderLastName | titleCase }}
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="end start">
                                                <span>({{ item.ResponderLocalJobTitle }})</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <div *ngIf="!LoadedRequest?.Responses || !LoadedRequest?.Responses.length">
                                    There are no responses provided to this request at this time.
                                </div>
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="ResponseMode === 'EDIT'" class="padding-top">
                            <!-- <div><em>This request has not yet been responded to.</em></div> -->
                            <div *ngIf="!['DONEWINFO', 'DONENOINFO'].includes(LoadedRequest?.Status)">
                                In the space below, provide the response to the request. Be sure to include all information necessary
                                to complete the request, if possible. If the request cannot be completed, please indicate why in the
                                space provided.
                            </div>
                            <div *ngIf="['DONEWINFO', 'DONENOINFO'].includes(LoadedRequest?.Status)">
                                In the space below, you may provide an <u>optional, additional</u> response to the request, in addition
                                to the one already presented here.
                            </div>
                            <div class="margin-top">
                                <span style="color:red">Note:</span> All comments added here will be visible to <u>all</u> individuals
                                using the IRIS System, including the original request creator.
                            </div>
                            <mat-form-field appearance="outline" floatLabel="never">
                                <textarea
                                    matInput
                                    matTextareaAutosize
                                    [matAutosizeMinRows]="5"
                                    formControlName="Response"
                                    maxlength="5000"
                                    placeholder="Type response here..."
                                    #responseTA
                                ></textarea>
                                <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                                <mat-hint align="end">{{ RequestForm?.get('Response')?.value?.length || 0 }}/5000</mat-hint>
                                <mat-error *ngIf="RequestForm?.get('Response')?.hasError('required')">Required.</mat-error>
                                <mat-error *ngIf="RequestForm?.get('Response')?.hasError('maxLength')"
                                    >Over character limit (5000).</mat-error
                                >
                            </mat-form-field>
                            <mat-checkbox formControlName="ResponseConfidential"
                                >This response contains confidential student and/or parent information.</mat-checkbox
                            >
                        </div>
                        <!-- File Attachments div -->
                        <div *ngIf="IsiPad" class="margin-top">
                            <em *ngIf="ResponseMode === 'EDIT'"
                                >File attachment uploads may not be possible from an Apple iPhone or iPad device. To reliably upload
                                files, please log in to the IRIS system using a desktop device to upload file attachments.</em
                            >
                            <em *ngIf="ResponseMode === 'VIEW'"
                                >File attachment downloads may not be possible from an Apple iPhone or iPad device. To reliably
                                download files, please log in to the IRIS system using a desktop device to retrieve file
                                attachments.</em
                            >
                        </div>
                        <div class="margin-top">
                            <div *ngIf="ResponseMode === 'EDIT'" class="margin-top">
                                <em
                                    >If you wish to upload any file attachments as part of your response, please use the button below
                                    to select one or more files to be attached to this response. You can attach up to five (5) files
                                    and individual files are limited to 50MB in size.</em
                                >
                            </div>
                            <app-file-uploader
                                buttonText="Add Attachment(s)"
                                color="primary"
                                icon="attach_file"
                                (upload)="HandleUploadAttachment($event)"
                                *ngIf="ResponseMode === 'EDIT'"
                            ></app-file-uploader>
                            <div
                                *ngIf="
                                    ResponseMode === 'VIEW' &&
                                    ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                        LoadedRequest?.Status
                                    )
                                "
                            >
                                <span *ngIf="LoadedRequest?.ResponseAttachments && !!LoadedRequest?.ResponseAttachments.length"
                                    >The following file attachments were attached to the response to this request:</span
                                >
                                <span *ngIf="!LoadedRequest?.ResponseAttachments || !LoadedRequest?.ResponseAttachments.length"
                                    >There are no file attachments attached to the response to this request at this time.</span
                                >
                            </div>
                            <div
                                *ngIf="CanTakeActions === true && RequestForm?.get('ResponseUploadAttachments')?.length"
                                class="margin-top"
                            >
                                The following files will be attached to this response:
                            </div>
                            <table
                                class="mat-table fullwidth margin-top row-margin"
                                *ngIf="
                                    (LoadedRequest?.Status === 'REFERRED' || LoadedRequest?.Status === 'REFTIMEAPP') &&
                                    RequestForm?.get('ResponseUploadAttachments')?.length
                                "
                            >
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">File Name</th>
                                        <th class="mat-header-cell centered">File Size</th>
                                        <th class="mat-header-cell centered">Action</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="ResponseUploadAttachments">
                                    <tr
                                        class="mat-row"
                                        *ngFor="let item of RequestForm?.get('ResponseUploadAttachments')?.controls; index as $index"
                                        [formGroup]="item"
                                    >
                                        <td class="mat-cell">
                                            <div>{{ item.get('File')?.value.name }}</div>
                                        </td>
                                        <td class="mat-cell centered">
                                            <div>{{ item.get('File')?.value.size | fileSize }}</div>
                                        </td>
                                        <td class="mat-cell">
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                <button type="button" mat-raised-button color="warn" (click)="RemoveFile($index)">
                                                    Remove
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="mat-row" *ngIf="!RequestForm?.get('ResponseUploadAttachments')?.controls.length">
                                        <td class="mat-cell" colspan="3">
                                            <em>There are no files attached to the response to this request.</em>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- Attachments to response table -->
                            <table
                                class="mat-table fullwidth margin-top row-margin"
                                *ngIf="
                                    ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO'].includes(LoadedRequest?.Status) &&
                                    LoadedRequest?.ResponseAttachments &&
                                    !!LoadedRequest?.ResponseAttachments.length
                                "
                            >
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">File Name</th>
                                        <th class="mat-header-cell centered">File Size</th>
                                        <th class="mat-header-cell centered">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="mat-row" *ngFor="let item of LoadedRequest?.ResponseAttachments; index as $index">
                                        <td class="mat-cell">
                                            <div>{{ item.FileName }}</div>
                                        </td>
                                        <td class="mat-cell centered">
                                            <div>{{ item.FileSize | fileSize }}</div>
                                        </td>
                                        <td class="mat-cell">
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    color="primary"
                                                    (click)="HandleFileAttachment(item)"
                                                >
                                                    Download
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="mat-row" *ngIf="!RequestForm?.get('ResponseAttachments')?.controls.length">
                                        <td class="mat-cell" colspan="3">
                                            <em>There are no files attached to the response to this request.</em>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div
                            *ngIf="
                                ['Developer', 'Facilitator'].includes(User.CurrentRole) &&
                                ['DENIED', 'UNAVAIL', 'COMPLETED', 'CLOSEDNONINFO'].includes(LoadedRequest?.Status)
                            "
                            fxLayout="row"
                            fxLayoutAlign="center center"
                            class="margin-top"
                        >
                            <button type="button" mat-raised-button color="accent" (click)="ForkRequest()">
                                Create New Related Request
                            </button>
                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="LoadedRequest?.FollowUps && LoadedRequest?.FollowUps.length">
                        <ng-template mat-tab-label>Follow-Up Request</ng-template>
                        <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                            <div>
                                This is the follow-up question / text entered by the original creator of the request at
                                {{ (LoadedRequest?.FollowUps)[0].DateRequested | date: 'M/d/yyyy h:mm a' }}:
                            </div>
                            <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].FollowUpQuestion }}</div>
                            <div
                                *ngIf="!(LoadedRequest?.FollowUps)[0].Response && !['Cabinet', 'Responder'].includes(User.CurrentRole)"
                            >
                                <em>There is no response provided to this follow-up question / text at this time.</em>
                            </div>
                            <div *ngIf="(LoadedRequest?.FollowUps)[0].Response">
                                <em
                                    >The following response was provided by
                                    <strong
                                        >{{ (LoadedRequest?.FollowUps)[0].RespondedByFullName | titleCase
                                        }}<span *ngIf="(LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle">
                                            ({{ (LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle }})</span
                                        ></strong
                                    >
                                    on {{ (LoadedRequest?.FollowUps)[0].DateResponded | date: 'M/d/yyyy h:mm a' }}:</em
                                >
                                <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].Response }}</div>
                            </div>
                            <ng-container
                                *ngIf="
                                    !(LoadedRequest?.FollowUps)[0].Response &&
                                    ['Cabinet', 'Responder'].includes(User.CurrentRole) &&
                                    LoadedRequest?.Status === 'FOLLOWUP'
                                "
                            >
                                <div>
                                    Please enter your response to the follow-up question / text shown above in the space provided
                                    below, and click the "Submit Follow-Up Response" button to submit your response to this follow-up
                                    request.
                                </div>
                                <div class="margin-top">
                                    <span style="color:red">Note:</span> All comments added here will be visible to
                                    <u>all</u> individuals using the IRIS System, including the original request creator.
                                </div>
                                <mat-form-field appearance="outline" floatLabel="never">
                                    <textarea
                                        matInput
                                        matTextareaAutosize
                                        [matAutosizeMinRows]="5"
                                        formControlName="FollowUpResponse"
                                        maxlength="5000"
                                        placeholder="Type response here..."
                                    ></textarea>
                                    <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                                    <mat-hint align="end"
                                        >{{ RequestForm?.get('FollowUpResponse')?.value?.length || 0 }}/5000</mat-hint
                                    >
                                    <mat-error *ngIf="RequestForm?.get('FollowUpResponse')?.hasError('maxLength')"
                                        >Over character limit (5000).</mat-error
                                    >
                                </mat-form-field>
                                <div *ngIf="IsiPad" class="margin-top">
                                    <em
                                        >File attachment uploads may not be possible from an Apple iPhone or iPad device. To reliably
                                        upload files, please log in to the IRIS system using a desktop device to upload file
                                        attachments.</em
                                    >
                                </div>
                                <div class="margin-top">
                                    <div>
                                        <em
                                            >If you wish to include file attachments as part of your response to this follow-up
                                            request, please use the button below to select one or more files to be attached to this
                                            response. You can attach up to five (5) files and individual files are limited to 50MB in
                                            size.</em
                                        >
                                    </div>
                                    <app-file-uploader
                                        buttonText="Add Attachment(s)"
                                        color="primary"
                                        icon="attach_file"
                                        (upload)="HandleUploadAttachment($event, true)"
                                    ></app-file-uploader>
                                    <ng-container
                                        *ngIf="
                                            LoadedRequest?.Status === 'FOLLOWUP' &&
                                            RequestForm?.get('FollowUpUploadAttachments')?.length
                                        "
                                    >
                                        <div class="margin-top">Files which will be attached to response to follow-up request:</div>
                                        <table class="mat-table fullwidth margin-top row-margin">
                                            <thead>
                                                <tr class="mat-header-row">
                                                    <th class="mat-header-cell">File Name</th>
                                                    <th class="mat-header-cell centered">File Size</th>
                                                    <th class="mat-header-cell centered">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody formArrayName="FollowUpUploadAttachments">
                                                <tr
                                                    class="mat-row"
                                                    *ngFor="
                                                        let item of RequestForm?.get('FollowUpUploadAttachments')?.controls;
                                                        index as $index
                                                    "
                                                    [formGroup]="item"
                                                >
                                                    <td class="mat-cell">
                                                        <div>{{ item.get('File')?.value.name }}</div>
                                                    </td>
                                                    <td class="mat-cell centered">
                                                        <div>{{ item.get('File')?.value.size | fileSize }}</div>
                                                    </td>
                                                    <td class="mat-cell">
                                                        <div fxLayout="row" fxLayoutAlign="center center">
                                                            <button
                                                                type="button"
                                                                mat-raised-button
                                                                color="warn"
                                                                (click)="RemoveFile($index, true)"
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr
                                                    class="mat-row"
                                                    *ngIf="!RequestForm?.get('FollowUpUploadAttachments')?.controls.length"
                                                >
                                                    <td class="mat-cell" colspan="3">
                                                        <em>There are no files attached to the response to this follow-up request.</em>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center center" class="margin-top">
                                    <button
                                        type="button"
                                        mat-raised-button
                                        color="primary"
                                        (click)="SubmitFollowUpResponse()"
                                        [disabled]="!RequestForm?.get('FollowUpResponse')?.value"
                                    >
                                        Submit Follow-Up Response
                                    </button>
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                        LoadedRequest?.Status
                                    ) && LoadedRequest?.FollowUpAttachments?.length
                                "
                            >
                                <div>
                                    <span
                                        >The following file attachments were attached to the response to this follow-up request:</span
                                    >
                                </div>
                                <table class="mat-table fullwidth margin-top row-margin">
                                    <thead>
                                        <tr class="mat-header-row">
                                            <th class="mat-header-cell">File Name</th>
                                            <th class="mat-header-cell centered">File Size</th>
                                            <th class="mat-header-cell centered">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="mat-row" *ngFor="let item of LoadedRequest?.FollowUpAttachments; index as $index">
                                            <td class="mat-cell">
                                                <div>{{ item.FileName }}</div>
                                            </td>
                                            <td class="mat-cell centered">
                                                <div>{{ item.FileSize | fileSize }}</div>
                                            </td>
                                            <td class="mat-cell">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button
                                                        type="button"
                                                        mat-raised-button
                                                        color="primary"
                                                        (click)="HandleFileAttachment(item)"
                                                    >
                                                        Download
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="mat-row" *ngIf="!RequestForm?.get('FollowUpAttachments')?.controls.length">
                                            <td class="mat-cell" colspan="3">
                                                <em>There are no files attached to the response to this follow-up request.</em>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </section>
            <mat-accordion *ngIf="SmallSize" [multi]="true">
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header> <mat-panel-title>Request / Concern</mat-panel-title> </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>This is the request / concern entered by the original creator of the request:</div>
                        <div class="usertext">{{ LoadedRequest?.RequestText }}</div>
                        <div *ngIf="LoadedRequest?.Confidential">
                            <strong
                                >Note: This request has been marked as containing confidential student and/or parent
                                information.</strong
                            >
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span>{{
                                'Request Attachments (' +
                                    (LoadedRequest?.RequestAttachments?.length ? LoadedRequest?.RequestAttachments?.length : 'None') +
                                    ')'
                            }}</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div *ngIf="IsiPad && LoadedRequest && !!LoadedRequest?.RequestAttachments.length" class="padding-top">
                            <em
                                >File attachment downloads may not be possible from an Apple iPhone or iPad device. To reliably
                                download files, please log in to the IRIS system using a desktop device to retrieve file
                                attachments.</em
                            >
                        </div>
                        <div class="padding-top">
                            <div *ngIf="!LoadedRequest || !LoadedRequest?.RequestAttachments.length">
                                There are no files attached to this request.
                            </div>
                            <div *ngIf="LoadedRequest && !!LoadedRequest?.RequestAttachments.length">
                                <em>The following file attachments were attached to this request when it was created:</em>
                            </div>
                            <div *ngIf="LoadedRequest && !!LoadedRequest?.RequestAttachments.length">
                                <div
                                    *ngFor="let item of LoadedRequest?.RequestAttachments; even as $even"
                                    [class.primarybackground50]="$even"
                                    fxLayout="column"
                                    fxLayoutAlign="start stretch"
                                    class="padded-bottom"
                                >
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Name</div>
                                        <div>{{ item.FileName }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Size</div>
                                        <div>{{ item.FileSize | fileSize }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center start" class="margin-top">
                                        <button type="button" mat-raised-button color="primary" (click)="HandleFileAttachment(item)">
                                            Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel
                    *ngIf="
                        (LoadedRequest?.Comments && !!LoadedRequest?.Comments.length) ||
                        ['Developer', 'Facilitator'].includes(User.CurrentRole)
                    "
                    [expanded]="true"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title> <span>Internal Request Notes</span> </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            The following internal notes have been attached to this referral by previous handlers of the request:
                        </div>
                        <div *ngFor="let com of CommentsData.data; even as $even" [class.primarybackground50]="$even">
                            <div fxLayout="column" fxLayoutAlign="start stretch">
                                <div fxLayout="row" fxLayoutAlign="space-between start">
                                    <div>Comment Date:</div>
                                    <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between start">
                                    <div>Commenter:</div>
                                    <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start stretch">
                                    <div>Comment:</div>
                                    <div [innerHTML]="com.Comment"></div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!CommentsData?.data || !CommentsData?.data?.length">
                            <em>No internal notes have been attached to this referral at this time.</em>
                        </div>
                        <button
                            type="button"
                            *ngIf="['Developer', 'Facilitator'].includes(User.CurrentRole)"
                            mat-raised-button
                            color="primary"
                            (click)="AddBoardNote()"
                        >
                            Add Note To Board Member
                        </button>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel *ngIf="ResponseMode != null" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title> Resolution / Response </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div *ngIf="LoadedRequest?.Status === 'DENIED'">
                            There was no response provided to this request. The request was closed because the amount of time required
                            to complete the request was not approved.
                        </div>
                        <div *ngIf="LoadedRequest?.Status === 'CLOSEDNONINFO'">
                            There was no response provided to this request. The request was closed because the request was not a
                            request for information.
                        </div>
                        <div *ngIf="LoadedRequest?.Status !== 'DENIED' && LoadedRequest?.Status !== 'CLOSEDNONINFO'">
                            <div *ngIf="LoadedRequest?.Responses && !!LoadedRequest?.Responses.length">
                                <em>
                                    <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length > 1"
                                        >The following responses were provided by individuals responding to this request:</span
                                    >
                                    <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length === 1"
                                        >The following response was provided by the individual responding to this request:</span
                                    >
                                </em>
                            </div>
                            <div *ngIf="LoadedRequest?.Responses && !!LoadedRequest?.Responses.length">
                                <div
                                    *ngFor="let item of LoadedRequest?.Responses; index as $index"
                                    fxLayout="column"
                                    fxLayoutAlign="start stretch"
                                    fxLayoutGap="5px"
                                >
                                    <div><strong>Response:</strong></div>
                                    <em>{{ item.Response }}</em>
                                    <div *ngIf="item.Confidential">
                                        <strong
                                            >Note: The creator of this response has marked this response as containing confidential
                                            student and/or parent information.</strong
                                        >
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <span><strong>Date Added</strong></span>
                                        <div>{{ item.DateAdded | date: 'M/d/yyyy' }}</div>
                                    </div>
                                    <div
                                        *ngIf="User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant'"
                                        fxLayout="column"
                                        fxLayoutAlign="start stretch"
                                    >
                                        <span><strong>Responder:</strong></span>
                                        <div fxLayout="row" fxLayoutAlign="end start">
                                            <div *ngIf="item.ResponderDesigneeSAPID">
                                                {{ item.ResponderDesigneeFirstName | titleCase }}
                                                {{ item.ResponderDesigneeLastName | titleCase }}
                                            </div>
                                        </div>
                                        <div *ngIf="item.ResponderDesigneeSAPID" fxLayout="row" fxLayoutAlign="end start">
                                            <span>({{ item.ResponderDesigneeLocalJobTitle }})</span>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="end start">
                                            <div *ngIf="item.ResponderDesigneeSAPID">
                                                <em><strong>providing response on behalf of</strong></em>
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="end start">
                                            <div>
                                                {{ item.ResponderFirstName | titleCase }} {{ item.ResponderLastName | titleCase }}
                                            </div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="end start">
                                            <span>({{ item.ResponderLocalJobTitle }})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!LoadedRequest?.Responses || !LoadedRequest?.Responses.length">
                                There are no responses provided to this request at this time.
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="ResponseMode === 'EDIT'" class="padding-top">
                        <!-- <div><em>This request has not yet been responded to.</em></div> -->
                        <div *ngIf="!['DONEWINFO', 'DONENOINFO'].includes(LoadedRequest?.Status)">
                            In the space below, provide the response to the request. Be sure to include all information necessary to
                            complete the request, if possible. If the request cannot be completed, please indicate why in the space
                            provided.
                        </div>
                        <div *ngIf="['DONEWINFO', 'DONENOINFO'].includes(LoadedRequest?.Status)">
                            In the space below, you may provide an <u>optional, additional</u> response to the request, in addition to
                            the one already presented here.
                        </div>
                        <div class="margin-top">
                            <span style="color:red">Note:</span> All comments added here will be visible to <u>all</u> individuals
                            using the IRIS System, including the original request creator.
                        </div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <textarea
                                matInput
                                matTextareaAutosize
                                [matAutosizeMinRows]="5"
                                formControlName="Response"
                                maxlength="5000"
                                placeholder="Type response here..."
                                #responseTA
                            ></textarea>
                            <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                            <mat-hint align="end">{{ RequestForm?.get('Response')?.value?.length || 0 }}/5000</mat-hint>
                            <mat-error *ngIf="RequestForm?.get('Response')?.hasError('required')">Required.</mat-error>
                            <mat-error *ngIf="RequestForm?.get('Response')?.hasError('maxLength')"
                                >Over character limit (5000).</mat-error
                            >
                        </mat-form-field>
                        <mat-checkbox formControlName="ResponseConfidential"
                            >This response contains confidential student and/or parent information.</mat-checkbox
                        >
                        <div *ngIf="IsiPad" class="margin-top margin-bottom">
                            <em
                                >File attachment uploads may not be possible from an Apple iPhone or iPad device. To reliably upload
                                files, please log in to the IRIS system using a desktop device to upload file attachments.</em
                            >
                        </div>
                        <div [class.margin-top]="!IsiPad">
                            <div *ngIf="ResponseMode === 'EDIT'">
                                <em
                                    >If you wish to upload any file attachments as part of your response, please use the button below
                                    to select one or more files to be attached to this response. You can attach up to five (5) files
                                    and individual files are limited to 50MB in size.</em
                                >
                            </div>
                            <app-file-uploader
                                buttonText="Add Attachment(s)"
                                color="primary"
                                icon="attach_file"
                                (upload)="HandleUploadAttachment($event)"
                                *ngIf="ResponseMode === 'EDIT'"
                            ></app-file-uploader>
                            <div
                                *ngIf="
                                    ResponseMode === 'VIEW' &&
                                    ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                        LoadedRequest?.Status
                                    )
                                "
                            >
                                <span *ngIf="LoadedRequest?.ResponseAttachments && !!LoadedRequest?.ResponseAttachments.length"
                                    >The following file attachments were attached to the response to this request:</span
                                >
                                <span *ngIf="!LoadedRequest?.ResponseAttachments || !LoadedRequest?.ResponseAttachments.length"
                                    >There are no file attachments attached to the response to this request at this time.</span
                                >
                            </div>
                            <div
                                *ngIf="CanTakeActions === true && RequestForm?.get('ResponseUploadAttachments')?.length"
                                class="margin-top"
                            >
                                The following files will be attached to your response:
                            </div>
                            <div
                                *ngIf="
                                    (LoadedRequest?.Status === 'REFERRED' || LoadedRequest?.Status === 'REFTIMEAPP') &&
                                    RequestForm?.get('ResponseUploadAttachments')?.length
                                "
                                formArrayName="ResponseUploadAttachments"
                            >
                                <div
                                    *ngFor="
                                        let item of RequestForm?.get('ResponseUploadAttachments')?.controls;
                                        index as $index;
                                        even as $even
                                    "
                                    [class.primarybackground50]="$even"
                                    [formGroup]="item"
                                    class="padding-bottom"
                                >
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Name</div>
                                        <div>{{ item.get('File')?.value.name }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Size</div>
                                        <div>{{ item.get('File')?.value.size | fileSize }}</div>
                                    </div>
                                    <div class="margin-top" fxLayout="row" fxLayoutAlign="center start">
                                        <button type="button" mat-raised-button color="warn" (click)="RemoveFile($index)">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        fxLayout="column"
                        fxLayoutAlign="start stretch"
                        *ngIf="
                            ResponseMode === 'VIEW' &&
                            ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                LoadedRequest?.Status
                            ) &&
                            LoadedRequest?.ResponseAttachments?.length
                        "
                        class="padding-top"
                    >
                        <div *ngIf="IsiPad" class="margin-top">
                            <em
                                >File attachment downloads may not be possible from an Apple iPhone or iPad device. To reliably
                                download files, please log in to the IRIS system using a desktop device to retrieve file
                                attachments.</em
                            >
                        </div>
                        <div class="margin-top">The following file attachments were attached to the response to this request:</div>
                        <div
                            *ngFor="let item of LoadedRequest?.ResponseAttachments; even as $even"
                            fxLayout="column"
                            fxLayoutAlign="start stretch"
                            [class.primarybackground50]="$even"
                            class="padding-bottom"
                        >
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <div>File Name</div>
                                <div>{{ item.FileName }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <div>File Size</div>
                                <div>{{ item.FileSize | fileSize }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center start" class="margin-top">
                                <button type="button" mat-raised-button color="primary" (click)="HandleFileAttachment(item)">
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            ['Developer', 'Facilitator'].includes(User.CurrentRole) &&
                            ['DENIED', 'UNAVAIL', 'COMPLETED', 'CLOSEDNONINFO'].includes(LoadedRequest?.Status)
                        "
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        class="margin-top"
                    >
                        <button type="button" mat-raised-button color="accent" (click)="ForkRequest()">
                            Create New Related Request
                        </button>
                    </div>
                </mat-expansion-panel>
                <!-- <mat-expansion-panel *ngIf="ResponseMode != null" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span>{{
                                'Response Attachments (' +
                                    (LoadedRequest?.ResponseAttachments?.length
                                        ? LoadedRequest?.ResponseAttachments?.length
                                        : 'None') +
                                    ')'
                            }}</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div *ngIf="IsiPad">
                            <em
                                >File attachment uploads may not be possible from an Apple iPhone or iPad device. To reliably upload
                                files, please log in to the IRIS system using a desktop device to upload file attachments.</em
                            >
                        </div>
                        <div>
                            <div *ngIf="ResponseMode === 'EDIT'">
                                <em
                                    >Please use the button below to select one or more files to be attached to this response. You can
                                    attach up to five (5) files and individual files are limited to 50MB in size.</em
                                >
                            </div>
                            <app-file-uploader
                                buttonText="Add Attachment(s)"
                                color="primary"
                                icon="attach_file"
                                (upload)="HandleUploadAttachment($event)"
                                *ngIf="ResponseMode === 'EDIT'"
                            ></app-file-uploader>
                            <div
                                *ngIf="
                                    ResponseMode === 'VIEW' &&
                                    ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                        LoadedRequest?.Status
                                    )
                                "
                            >
                                <span *ngIf="LoadedRequest?.ResponseAttachments && !!LoadedRequest?.ResponseAttachments.length"
                                    >The following file attachments were attached to the response to this request:</span
                                >
                                <span *ngIf="!LoadedRequest?.ResponseAttachments || !LoadedRequest?.ResponseAttachments.length"
                                    >There are no file attachments attached to the response to this request at this time.</span
                                >
                            </div>
                            <div *ngIf="CanTakeActions === true" class="margin-top">Files to attach to response:</div>
                            <div
                                *ngIf="LoadedRequest?.Status === 'REFERRED' || LoadedRequest?.Status === 'REFTIMEAPP'"
                                formArrayName="ResponseUploadAttachments"
                            >
                                <div
                                    *ngFor="
                                        let item of RequestForm?.get('ResponseUploadAttachments')?.controls;
                                        index as $index;
                                        even as $even
                                    "
                                    [class.primarybackground50]="$even"
                                    [formGroup]="item"
                                    class="padding-bottom"
                                >
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Name</div>
                                        <div>{{ item.get('File')?.value.name }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Size</div>
                                        <div>{{ item.get('File')?.value.size | fileSize }}</div>
                                    </div>
                                    <div class="margin-top" fxLayout="row" fxLayoutAlign="center start">
                                        <button type="button" mat-raised-button color="warn" (click)="RemoveFile($index)">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="!RequestForm?.get('ResponseUploadAttachments')?.controls.length">
                                    <em>There are no files attached to the response to this request.</em>
                                </div>
                            </div>
                            <div
                                *ngIf="
                                    !['REFERRED', 'REFTIMEAPP'].includes(LoadedRequest?.Status) &&
                                    LoadedRequest?.ResponseAttachments &&
                                    !!LoadedRequest?.ResponseAttachments.length
                                "
                            >
                                <div
                                    *ngFor="let item of LoadedRequest?.ResponseAttachments; even as $even"
                                    fxLayout="column"
                                    fxLayoutAlign="start stretch"
                                    [class.primarybackground50]="$even"
                                    class="padding-bottom"
                                >
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Name</div>
                                        <div>{{ item.FileName }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>File Size</div>
                                        <div>{{ item.FileSize | fileSize }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center start" class="margin-top">
                                        <button type="button" mat-raised-button color="primary" (click)="HandleFileAttachment(item)">
                                            Download
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="!RequestForm?.get('ResponseAttachments')?.controls.length">
                                    <em>There are no files attached to the response to this request.</em>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel> -->
                <mat-expansion-panel *ngIf="LoadedRequest?.FollowUps && LoadedRequest?.FollowUps.length" [expanded]="true">
                    <mat-expansion-panel-header> <mat-panel-title>Follow-Up Request</mat-panel-title> </mat-expansion-panel-header>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            This is the follow-up question / text entered by the original creator of the request at
                            {{ (LoadedRequest?.FollowUps)[0].DateRequested | date: 'M/d/yyyy h:mm a' }}:
                        </div>
                        <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].FollowUpQuestion }}</div>
                        <div *ngIf="!(LoadedRequest?.FollowUps)[0].Response && !['Cabinet', 'Responder'].includes(User.CurrentRole)">
                            <em>There is no response provided to this follow-up question / text at this time.</em>
                        </div>
                        <div *ngIf="(LoadedRequest?.FollowUps)[0].Response">
                            <em
                                >The following response was provided by
                                <strong
                                    >{{ (LoadedRequest?.FollowUps)[0].RespondedByFullName | titleCase
                                    }}<span *ngIf="(LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle">
                                        ({{ (LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle }})</span
                                    ></strong
                                >
                                on {{ (LoadedRequest?.FollowUps)[0].DateResponded | date: 'M/d/yyyy h:mm a' }}:</em
                            >
                            <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].Response }}</div>
                        </div>
                        <ng-container
                            *ngIf="
                                !(LoadedRequest?.FollowUps)[0].Response &&
                                ['Cabinet', 'Responder'].includes(User.CurrentRole) &&
                                LoadedRequest?.Status === 'FOLLOWUP'
                            "
                        >
                            <div>
                                Please enter your response to the follow-up question / text shown above in the space provided below,
                                and click the "Submit Follow-Up Response" button to submit your response to this follow-up request.
                            </div>
                            <div class="margin-top">
                                <span style="color:red">Note:</span> All comments added here will be visible to <u>all</u> individuals
                                using the IRIS System, including the original request creator.
                            </div>
                            <mat-form-field appearance="outline" floatLabel="never">
                                <textarea
                                    matInput
                                    matTextareaAutosize
                                    [matAutosizeMinRows]="5"
                                    formControlName="FollowUpResponse"
                                    maxlength="5000"
                                    placeholder="Type response here..."
                                ></textarea>
                                <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                                <mat-hint align="end">{{ RequestForm?.get('FollowUpResponse')?.value?.length || 0 }}/5000</mat-hint>
                                <mat-error *ngIf="RequestForm?.get('FollowUpResponse')?.hasError('maxLength')"
                                    >Over character limit (5000).</mat-error
                                >
                            </mat-form-field>
                            <div *ngIf="IsiPad" class="margin-top">
                                <em
                                    >File attachment uploads may not be possible from an Apple iPhone or iPad device. To reliably
                                    upload files, please log in to the IRIS system using a desktop device to upload file
                                    attachments.</em
                                >
                            </div>
                            <div class="margin-top">
                                <div>
                                    <em
                                        >If you wish to include file attachments as part of your response to this follow-up request,
                                        please use the button below to select one or more files to be attached to this response. You
                                        can attach up to five (5) files and individual files are limited to 50MB in size.</em
                                    >
                                </div>
                                <app-file-uploader
                                    buttonText="Add Attachment(s)"
                                    color="primary"
                                    icon="attach_file"
                                    (upload)="HandleUploadAttachment($event, true)"
                                ></app-file-uploader>
                                <ng-container
                                    *ngIf="
                                        LoadedRequest?.Status === 'FOLLOWUP' && RequestForm?.get('FollowUpUploadAttachments')?.length
                                    "
                                >
                                    <div class="margin-top">Files which will be attached to response to follow-up request:</div>
                                    <table class="mat-table fullwidth margin-top row-margin">
                                        <thead>
                                            <tr class="mat-header-row">
                                                <th class="mat-header-cell">File Name</th>
                                                <th class="mat-header-cell centered">File Size</th>
                                                <th class="mat-header-cell centered">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody formArrayName="FollowUpUploadAttachments">
                                            <tr
                                                class="mat-row"
                                                *ngFor="
                                                    let item of RequestForm?.get('FollowUpUploadAttachments')?.controls;
                                                    index as $index
                                                "
                                                [formGroup]="item"
                                            >
                                                <td class="mat-cell">
                                                    <div>{{ item.get('File')?.value.name }}</div>
                                                </td>
                                                <td class="mat-cell centered">
                                                    <div>{{ item.get('File')?.value.size | fileSize }}</div>
                                                </td>
                                                <td class="mat-cell">
                                                    <div fxLayout="row" fxLayoutAlign="center center">
                                                        <button
                                                            type="button"
                                                            mat-raised-button
                                                            color="warn"
                                                            (click)="RemoveFile($index, true)"
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                class="mat-row"
                                                *ngIf="!RequestForm?.get('FollowUpUploadAttachments')?.controls.length"
                                            >
                                                <td class="mat-cell" colspan="3">
                                                    <em>There are no files attached to the response to this follow-up request.</em>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center" class="margin-top">
                                <button
                                    type="button"
                                    mat-raised-button
                                    color="primary"
                                    (click)="SubmitFollowUpResponse()"
                                    [disabled]="!RequestForm?.get('FollowUpResponse')?.value"
                                >
                                    Submit Follow-Up Response
                                </button>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                    LoadedRequest?.Status
                                ) && LoadedRequest?.FollowUpAttachments?.length
                            "
                        >
                            <div>
                                <span>The following file attachments were attached to the response to this follow-up request:</span>
                            </div>
                            <table class="mat-table fullwidth margin-top row-margin">
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">File Name</th>
                                        <th class="mat-header-cell centered">File Size</th>
                                        <th class="mat-header-cell centered">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="mat-row" *ngFor="let item of LoadedRequest?.FollowUpAttachments; index as $index">
                                        <td class="mat-cell">
                                            <div>{{ item.FileName }}</div>
                                        </td>
                                        <td class="mat-cell centered">
                                            <div>{{ item.FileSize | fileSize }}</div>
                                        </td>
                                        <td class="mat-cell">
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    color="primary"
                                                    (click)="HandleFileAttachment(item)"
                                                >
                                                    Download
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="mat-row" *ngIf="!LoadedRequest?.FollowUpAttachments?.length">
                                        <td class="mat-cell" colspan="3">
                                            <em>There are no files attached to the response to this follow-up request.</em>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <div
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="15px"
                class="actionbar margin-bottom"
                *ngIf="LoadedRequest?.Completed !== true && LoadedRequest?.Cancelled !== true"
                fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="center center"
            >
                <button
                    type="button"
                    *ngIf="ActionButtons?.ForwardReferral"
                    mat-raised-button
                    color="primary"
                    (click)="ForwardReferral()"
                >
                    Forward Referral
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.FacilitatorRedirect"
                    mat-raised-button
                    color="warn"
                    (click)="RedirectRequest()"
                >
                    Redirect This Request
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.FacilitatorRecall"
                    mat-raised-button
                    color="warn"
                    (click)="RecallRequest()"
                >
                    Recall This Request
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.SecondForwardReferral"
                    mat-raised-button
                    color="primary"
                    (click)="ForwardReferral(LoadedRequest?.SecondResponderInfo)"
                >
                    Return to {{ LoadedRequest?.SecondResponderInfo?.FirstName | titleCase }}
                    {{ LoadedRequest?.SecondResponderInfo?.LastName | titleCase }}
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.SubmitResponse"
                    [disabled]="!RequestForm?.get('Response')?.value"
                    mat-raised-button
                    color="primary"
                    (click)="HandleSubmitResponse()"
                >
                    Submit Final Response
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.PushResponse"
                    mat-raised-button
                    color="primary"
                    (click)="HandleSubmitResponse()"
                >
                    Submit Final Response
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.MarkUnavailable || ActionButtons?.PushUnavailable"
                    mat-raised-button
                    color="accent"
                    (click)="HandleInfoUnavailable()"
                >
                    Mark Info Unavailable
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.RequestTime || ActionButtons?.PushRequestTime"
                    mat-raised-button
                    color="warn"
                    (click)="HandleTimeRequest()"
                >
                    Request Time Approval
                </button>
                <button
                    type="button"
                    *ngIf="ActionButtons?.BoardApprove"
                    mat-raised-button
                    color="accent"
                    (click)="BoardTimeApprove()"
                >
                    Mark Time Request As Board Approved
                </button>
                <button type="button" *ngIf="ActionButtons?.BoardDeny" mat-raised-button color="warn" (click)="BoardTimeDeny()">
                    Mark Time Request As Board Denied
                </button>
            </div>
        </form>
    </div>
</div>
